/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > * + *": {
      marginLeft: theme.spacing(2)
    },
    paddingBottom: 8,
    paddingRight: 12,
    position: "relative",
    bottom: 0,
    textAlign: "right"
  }
}));

const FooterLink = withRouter((props) => {
  const classes = useStyles();

  return (
    props.location.pathname !== "/login" && (
      <Typography className={classes.root}>
        <Link component={RouterLink} to="/about">
          © {new Date().getFullYear()} Carat Detroit
        </Link>
      </Typography>
    )
  );
});

export default FooterLink;
